import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  videoBar: {
    marginRight: '20px',
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  videoButton: {
    background: palette.shades[200],
    color: palette.shades[800],
    borderRadius: '0',
    padding: '18px 24px',
    '& .MuiSvgIcon-root': {
      marginRight: '8px'
    },
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: palette.shades[300],
      '.MuiSvgIcon-root path': {
        fill: palette.shades[800]
      }
    },
    '&.Mui-focusVisible': {
      backgroundColor: palette.shades[300],
      '.MuiSvgIcon-root path': {
        fill: palette.shades[800]
      }
    }
  }
});
export default useStyles;